import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: ${props => props.theme.size.spacing['2xl']};
`
const Main = styled.main`
  display: flex;
  flex-direction: column;
`

export { Container, Main }
